import axios from "axios";
import { config } from "./config";

const axiosInstance = axios.create({
  baseURL: config.API_BASE_URL,
  withCredentials: false,
  timeout: 30000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Define login endpoints that should be excluded from 401 handling
    const loginEndpoints = [
      '/dashboard/auth/login',
      '/dashboard/auth/business/login'
    ];

    // Check if the request URL is a login endpoint
    const requestUrl = error?.config?.url;
    const isLoginEndpoint = loginEndpoints.some(endpoint =>
      requestUrl?.includes(endpoint)
    );

    if (error?.response?.status === 401 && !isLoginEndpoint) {
      // Handle unauthorized - clear auth data and redirect to login
      const authUser = localStorage.getItem("authUser");
      let userRole = null;

      try {
        if (authUser) {
          const user = JSON.parse(authUser);
          userRole = user?.role?.toLowerCase();
        }
      } catch (e) {
        // Invalid JSON, ignore
      }

      localStorage.removeItem("authToken");
      localStorage.removeItem("authUser");

      // Redirect to appropriate login page based on user role
      if (userRole === "business") {
        window.location.href = "/login";
      } else {
        window.location.href = "/admin/auth/login";
      }
    }
    return Promise.reject(error);
  }
);

export const http = {
  get: async (url, config = {}) => {
    const response = await axiosInstance.get(url, config);
    return response.data;
  },

  post: async (url, data, config = {}) => {
    const isFormData = data instanceof FormData;
    const headers = isFormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" };

    const response = await axiosInstance.post(url, data, {
      ...config,
      headers: { ...headers, ...config.headers },
    });
    return response.data;
  },

  put: async (url, data, config = {}) => {
    const isFormData = data instanceof FormData;
    const headers = isFormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" };

    const response = await axiosInstance.put(url, data, {
      ...config,
      headers: { ...headers, ...config.headers },
    });
    return response.data;
  },

  delete: async (url, config = {}) => {
    const response = await axiosInstance.delete(url, config);
    return response.data;
  },

  patch: async (url, data, config = {}) => {
    const response = await axiosInstance.patch(url, data, config);
    return response.data;
  },
};

export { axiosInstance };
export default http;
